var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgYoutubeLogo = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8536 0.731583C21.8216 0.856885 22.7467 1.79219 22.8644 2.7676C23.2811 6.34232 23.2811 9.80872 22.8644 13.3823C22.7467 14.3577 21.8216 15.2941 20.8536 15.4183C14.9513 16.147 8.98225 16.147 3.08162 15.4183C2.1128 15.2939 1.1877 14.3577 1.06999 13.3823C0.653264 9.80844 0.653264 6.34232 1.06999 2.7676C1.1877 1.79219 2.1128 0.856606 3.08162 0.731583C8.98225 0.00288381 14.951 0.00288381 20.8536 0.731583ZM10.099 4.36283V11.7882L15.703 8.07566L10.099 4.36283Z",
    fill: "#1A1A1A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgYoutubeLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/youtube-logo.e40c511c.svg";
export { ForwardRef as ReactComponent };